export const iconFontAwesomeFilesFileCircleCheck = (
	<i className="fa-solid fa-file-circle-check"></i>
);
